import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSharedDocs } from "../../api/dashboard";
import { DocumentTable } from "../../components/DocumentTable";
import { LoadingScreen } from "../../components/LoadingScreen";

export const SharedDocuments = () => {
  const user = useSelector(state => state.user);
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useQuery(
    ["shared_docs", user.token],
    async () => {
      return getSharedDocs(user.token);
    }
  );

  return !isLoading ? (
    <>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            Recent documents shared with organisation "{user.department.name}"
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Most recently updated documents in your organisation
          </p>
        </div>
      </div>
      {data && data.documents ? (
        <DocumentTable
          showCreator={true}
          showOrganisation={true}
          documents={data.documents}
          loading={isLoading}
        />
      ) : (
        <div>No documents</div>
      )}
    </>
  ) : (
    <LoadingScreen />
  );
};
